import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import PhotoSizeServer from '@alltrails/types/PhotoSizeServer';

const sizeMapping: Record<PhotoSizeDimensions, PhotoSizeServer> = {
  '500x500': 'large',
  '1080x700': 'larger_wide',
  '2048x2048': 'extra_large',
  '50x50': 'icon',
  '80x80': 'small_square',
  '100x100': 'small',
  '200x200': 'medium',
  '120x120': 'medium_square',
  '160x160': 'large_square',
  '160x120': 'small_wide',
  '800x300': 'large_wide'
};

const getPhotoSizeServerFromDimensions = (dimensions: PhotoSizeDimensions) => {
  return sizeMapping[dimensions];
};

export default getPhotoSizeServerFromDimensions;
